module.exports = __webpack_public_path__ + "img/circle_one.a3beec70.png";